export default __webpack_public_path__ + "static/media/icons8-eshop.a95046ea.svg";